import { useState } from 'react';
import { addMinutes, addMonths } from 'date-fns';
import { compose } from 'ramda';

import {
  formatCalendarDatetime,
  formatMonthName,
} from '#src/lib/formatters/temporal';
import { secondsUntil } from '#src/lib/date-fns';

export { hasQuizOnboardingData } from './has-quiz-onboarding-data.js';

export const getTargetMonth = () => formatMonthName(addMonths(new Date(), 4));

export const useDescriptionModal = () => {
  const [visible, setVisibility] = useState(false);

  const show = setVisibility.bind(null, true);
  const hide = setVisibility.bind(null, false);

  return { hide, show, visible };
};

export const getCountdownExpirationDatetime = (date) => {
  // Display a 15 minutes (since order creation) countdown on the quiz cart
  return compose(formatCalendarDatetime, addMinutes)(new Date(date), 15);
};

export const getShowCountdown = (date) => {
  return compose(secondsUntil, getCountdownExpirationDatetime)(date) > 0;
};

export const getPlanHighlights = (promo) => {
  const creditCents = promo?.amount || 1000;
  return [
    { id: 4, text: `$${creditCents / 100} Free Credit`, featured: true },
    { id: 1, text: 'Coach support + guidance' },
    { id: 2, text: 'Community of people with similar goals' },
    { id: 3, text: 'Long-lasting habits for healthy weight' },
  ];
};

export { getPricePerWeek } from './get-price-per-week.js';
export { sortPlansBySubscriptionValue } from './sort-plans-by-subscription-value.js';
